/**
 * @file ClientSettingsTab.js
 * @description This file contains the ClientSettingsTab component, which is a reusable form for displaying and editing an individual's demographic information.
 */

import ClientSettingImports from './options/ClientSettingImports';
import ClientSettingAssets from './options/ClientSettingAssets';
import ClientSettingBenefits from './ClientSettingBenefits';
import ClientSettingCommunication from './options/ClientSettingCommunication';
import ClientSettingFieldNaming from './ClientSettingFieldNaming';
import ClientSettingSupportedLanguages from './options/ClientSettingSupportedLanguages';
import ClientSettingAccount from './options/ClientSettingAccount';
import ClientOptionContainer from './options/ClientOptionContainer';
import ClientOptionSecurity from './ClientOptionSecurity';
import ClientSettingAdditionalUsers from './ClientSettingAdditionalUsers';
import ClientSettingAdminAudience from './ClientSettingAdminAudience';
import ClientSettingDataPoints from './ClientSettingDataPoints';
import ClientSettingIndividualMenus from './options/ClientSettingIndividualMenus';
import { useAuthContext } from '../../store/Contexts';
import { TenantTiers } from '../../utils/data/enums';
import { getText } from '../../i18n';

const ClientSettingsTab = () => {
    const { clientTierMeetsRequirement } = useAuthContext();

    return (
        <div
            className="page-content"
            style={{ height: '100%', overflowY: 'auto' }}
        >
            <div className="card" style={{ minHeight: '100%' }}>
                <div
                    className="card-body px-0 py-4 d-flex flex-column"
                    style={{ minHeight: '100%' }}
                >
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <div
                            style={{ display: 'flex', flexDirection: 'column' }}
                        >
                            <p className="page-title float-start card-title ms-4 m-0">
                                {getText('msg_c7f73bb54d92')}
                            </p>
                        </div>
                    </div>
                    <div style={{ width: '80%', alignSelf: 'center' }}>
                        {clientTierMeetsRequirement(TenantTiers.Silver) && (
                            <ClientSettingAdminAudience />
                        )}

                        {clientTierMeetsRequirement(TenantTiers.Silver) && (
                            <ClientSettingDataPoints />
                        )}

                        {clientTierMeetsRequirement(TenantTiers.Silver) && (
                            <ClientSettingAdditionalUsers />
                        )}
                        <ClientOptionSecurity clientRecord={null} />

                        <ClientOptionContainer
                            title={getText('msg_20e338624cee')}
                            childComponent={<ClientSettingAssets />}
                        />

                        <ClientSettingBenefits />

                        <ClientOptionContainer
                            title={getText('msg_0d787aa80c19')}
                            childComponent={<ClientSettingIndividualMenus />}
                        />

                        {clientTierMeetsRequirement(TenantTiers.Bronze) && (
                            <ClientOptionContainer
                                title={getText('msg_e42328ac01cd')}
                                childComponent={<ClientSettingImports />}
                                description=""
                            />
                        )}

                        <ClientSettingFieldNaming />
                        <ClientOptionContainer
                            title={getText('msg_85dfa32c97d8')}
                            childComponent={<ClientSettingAccount />}
                            description={getText('msg_e17121e762d9')}
                        />

                        {clientTierMeetsRequirement(TenantTiers.Silver) && (
                            <ClientOptionContainer
                                title={getText('msg_db07be184479')}
                                childComponent={
                                    <ClientSettingSupportedLanguages />
                                }
                            />
                        )}

                        <ClientOptionContainer
                            title={getText('msg_ade0d50c9254')}
                            childComponent={<ClientSettingCommunication />}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ClientSettingsTab;
